module.exports = __webpack_public_path__ + "static/media/noHospital.dd0f65d2.png";